var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.media.type == 'audio')?_c('audio',{attrs:{"src":_vm.media.url,"controls":""}}):_vm._e(),(_vm.media.type == 'video')?_c('video',{attrs:{"src":_vm.media.url,"controls":""}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }